import React from "react";

import "./adscritos-block.component.scss";

const IMAGENES = [
  {
    src: "imagenes/adscritos/iiap.png",
    href: "http://www.iiap.gob.pe",
    alt: "IIAP"
  },
  {
    src: "imagenes/adscritos/oefa.png",
    href: "https://www.gob.pe/oefa",
    alt: "OEFA"
  },
  {
    src: "imagenes/adscritos/inaeigem.png",
    href: "https://www.inaigem.gob.pe",
    alt: "INAEIGEM"
  },
  {
    src: "imagenes/adscritos/sernanp.png",
    href: "https://www.sernanp.gob.pe",
    alt: "SERNANP"
  },
  {
    src: "imagenes/adscritos/senace.png",
    href: "https://www.senace.gob.pe/",
    alt: "SENACE"
  },
  {
    src: "imagenes/adscritos/igp.png",
    href: "https://www.igp.gob.pe",
    alt: "IGP"
  },
  {
    src: "imagenes/adscritos/senamhi.png",
    href: "https://www.senamhi.gob.pe",
    alt: "SENAMHI"
  }
];

class EnlasesExternos extends React.Component {
  render() {
    return (
      <div className="adscritos-block card">
        <div className="card-body footer-card-body">
          {IMAGENES.map((image, key) => {
            return (
              <a key={key}  href={image.href}  target="_blank" rel="noopener noreferrer">
                <img src={image.src} alt={image.alt} />
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}
export default EnlasesExternos;
